// extracted by mini-css-extract-plugin
export var addressFields = "_m7-0";
export var animationContainer = "_m7-1";
export var footer = "_m7-2";
export var lineItems = "_m7-3";
export var modalContent = "_m7-4";
export var orderName = "_m7-5";
export var strong = "_m7-6";
export var warning = "_m7-7";